export default {
    props: {
        groupDate: {
            type: Boolean,
            default: undefined,
            kComposite: 'group.date'
        }, 
        groupResources: {
            type: Array,
            default: undefined,
            kComposite: 'group.resources'
        }, 
        groupOrientation: {
            type: String,
            default: undefined,
            kComposite: 'group.orientation'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/Group.js